import { useEffect, useState } from "react";

import useData from "../../hooks/useData";

import AutoComplete from "../elements/AutoComplete";
import { Box } from "@mui/material";

const BannerSelect = ({ value, onChange }) => {
  const { getFromServer } = useData();

  const [options, setOptions] = useState(null);

  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    const results = await getFromServer({ entityName: "Banner", filter: {} });
    const options = [];

    for (const banner of results) {
      options.push({
        key: banner.id,
        id: banner.id,
        name: `${banner.name}`,
      });
    }

    setOptions(options);
  };

  const handleChange = (newValue) => {
    onChange(newValue);
  };

  if (!options) return null;

  return (
    <AutoComplete
      id={"banner"}
      label={"banner"}
      value={value || ""}
      onChange={(newValue) => handleChange(newValue)}
      items={options}
    />
  );
};

export default BannerSelect;
